import IconButton from '@/_application/core/components/ui/icon-button';
import {Image} from '@/_application/core/components/ui/image';
import {getImageAssetUrl} from '@/_application/core/utils/common';
import BackDrop from '@/_application/pages/home/components/backdrop';
import {isHiddenNavigationAtom} from '@/store/mobile-layout/mobile-layout';
import {useAtom} from 'jotai';
import {useEffect, useMemo, useState} from 'react';
import {DisplayOptions, DisplayOptionsType, DisplayToolbarProps} from './sorting-filter-toolbar.type';
import SortingTab from '@/_application/modules/categories/components/sorting-filter-toolbar/sorting-filter/sort/sorting-tab';
import FilterTab from '@/_application/modules/categories/components/sorting-filter-toolbar/sorting-filter/filter/filter-tab';

const FilterIcon = getImageAssetUrl('icons/filter.png');
const SortingIcon = getImageAssetUrl('icons/sorting.png');

const displayToolbarItems: DisplayOptions[] = [
    {type: DisplayOptionsType.SORTING, title: 'Sắp xếp theo', image: SortingIcon},
    {type: DisplayOptionsType.FILTERING, title: 'Bộ lọc', image: FilterIcon},
];

const SortingFilterToolbar: React.FC<DisplayToolbarProps> = ({aggregations, sortFields}) => {
    const [displayOptions, setDisplayOptions] = useState<DisplayOptionsType>(DisplayOptionsType.NONE);
    const [, setHiddenNavigationAction] = useAtom(isHiddenNavigationAtom);

    const closeOptionsBottomSheet = () => {
        setDisplayOptions(DisplayOptionsType.NONE);
    };

    useEffect(() => {
        if (displayOptions === DisplayOptionsType.NONE) {
            document.body.style.overflow = 'unset';
            setHiddenNavigationAction(false);
        } else {
            document.body.style.overflow = 'hidden';
            setHiddenNavigationAction(true);
        }
    }, [displayOptions]);

    // Filter key list
    const attributeCodeList = useMemo(() => {
        return aggregations?.map(aggregation => aggregation?.attribute_code);
    }, [JSON.stringify(aggregations)]);

    return (
        <div className={`z-20 `}>
            <div className="w-screen bg-white">
                {displayOptions !== DisplayOptionsType.NONE && <BackDrop onClose={closeOptionsBottomSheet} />}

                <div className="flex items-center justify-between py-3">
                    {displayToolbarItems.map(item => {
                        return (
                            <IconButton
                                whileTap={{scale: 0.9}}
                                onClick={() => setDisplayOptions(item.type)}
                                key={item.title}
                                className="flex content-center items-center justify-center rounded-xl border border-gray-200 py-2"
                                icon={<Image src={item.image} alt="Icon" height={16} width={16} />}
                                label={item.title}
                                labelClassName="ml-2"
                                style={{
                                    paddingLeft: 16,
                                    paddingRight: 16,
                                    width: '100%',
                                }}
                            />
                        );
                    })}
                </div>

                <div className="fixed bottom-0 left-0 right-0 z-10 rounded-t-xl bg-white">
                    {displayOptions === DisplayOptionsType.SORTING && (
                        <SortingTab sortFields={sortFields} onConfirm={closeOptionsBottomSheet} />
                    )}

                    {displayOptions === DisplayOptionsType.FILTERING && (
                        <FilterTab
                            attributeCodeList={attributeCodeList}
                            aggregationList={aggregations}
                            onConfirm={closeOptionsBottomSheet}
                        />
                    )}
                </div>
            </div>
        </div>
    );
};

export default SortingFilterToolbar;
